































import {
    computed,
    defineComponent,
    PropType,
    ref,
    watch,
} from '@vue/composition-api';
import Comment from '@/components/comment/index.vue';
import { Maybe, Feed } from '@/generated-models';
import { elapsedTime } from '@/common/util/time';
import { useBroadcast, useHoverListener } from '@/common/utils';
import Toast from '@/components/toast/index.vue';
export default defineComponent({
    props: {
        info: {
            type: Object as PropType<Maybe<Feed>>,
        },
        showComment: Boolean,
    },
    components: {
        Comment,
        Toast,
    },
    setup(props, { emit }) {
        const photoInfo = computed(() => props.info?.photo || {});
        const authorInfo = computed(() => props.info?.author || {});
        const canAddComment = computed(() => props.info?.canAddComment || 0);
        const inputPlaceholder = computed(() => (canAddComment.value === 0 ? '说点什么...' : '仅作者及作者好友可评论'));
        const authorName = computed(() => authorInfo.value.name || '');
        const authorAvatarUrl = computed(() => authorInfo.value.headerUrl || '');
        const caption = computed(() => photoInfo.value.caption || '');
        const profileUrl = computed(() => `/profile/${authorInfo.value.id}`);
        const publishTime = computed(() => String(elapsedTime({
            begin: new Date(photoInfo.value.timestamp),
            end: new Date(Math.max(photoInfo.value.timestamp, +new Date())),
        })));
        const commentDom = ref<HTMLDivElement | null>(null);
        const commentToast = ref<InstanceType<typeof Toast> | null>(null);
        const broadcast = useBroadcast();
        watch(() => props.showComment, val => {
            if (!val) {
                broadcast('clean-input', {});
            }
        });
        useHoverListener({
            element: commentDom,
            enter: () => {
                emit('enter-comment', true);
            },
            leave: () => {
                emit('enter-comment', false);
            },
            enterDelay: 100,
            leaveDelay: 100,
            force: true,
        });
        function handleBlockComment() {
            commentToast.value?.show('评论失败');
        }
        return {
            photoInfo,
            authorInfo,
            canAddComment,
            inputPlaceholder,
            authorName,
            authorAvatarUrl,
            caption,
            profileUrl,
            publishTime,
            commentDom,
            commentToast,
            handleBlockComment,
        };
    },
});
